import { createAction } from '@reduxjs/toolkit'

import { ActiveSourceResponse } from 'types/GlobalDataset'

export const getSourceSchemas = createAction('get_source_schemas')
export const getSourceSchemasSuccess = createAction<ActiveSourceResponse[]>(
  'get_source_schemas_success'
)
export const getSourceSchemasFailed = createAction('get_source_schemas_failed')
